import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '1.75rem',
    height: '1.75rem',
    color: 'white',
    padding: '0.5rem',
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
}));

export default useStyles;
